import { useInitData } from './useInitData'

export function useIsOragClusterDisplayed() {
  const initData = useInitData()

  // Backend exposes the flag as `display_oerag_cluster` (the DB column keeps the old `orag` name)
  return Boolean(initData?.uk?.config?.display_oerag_cluster)
}
